import { MapPin } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export function InPersonBadge() {
  return (
    <Badge
      className="h-auto gap-1 border-transparent px-2 py-1 text-data-card-xs font-semibold text-white [&>svg]:size-[clamp(10px,0.85vw,12px)]!"
      style={{ backgroundColor: 'var(--color-mr-teal-dark)' }}
    >
      <MapPin aria-hidden />
      In person
    </Badge>
  );
}
